import { sortBy } from "lodash/fp";

import { get } from "@readai/common/api";
import { parseUTCDateTimeFromString } from "@readai/common/utils/datetimeUtils";

import type {
  ApiPublicRssLink,
  PublicRssLink,
} from "@app/booking/types/rssLinkTypes";

const parsePublicLink = ({
  windowStartTime,
  windowEndTime,
  ...link
}: ApiPublicRssLink) => ({
  ...link,
  windowStartTime: parseUTCDateTimeFromString(windowStartTime),
  windowEndTime: parseUTCDateTimeFromString(windowEndTime),
});

const parsePublicLinks = (links: ApiPublicRssLink[]) =>
  links.map(parsePublicLink);

export const listPublicRssLinks = async (
  vanityId: string,
): Promise<PublicRssLink[]> => {
  const response: ApiPublicRssLink[] = await get(
    `/public_rss_links/${encodeURIComponent(vanityId)}`,
  );

  return sortBy("allowedDuration", parsePublicLinks(response));
};

export const getPublicRssLink = async (
  ownerVanityId: string,
  linkId: string,
) => {
  const response: ApiPublicRssLink = await get(
    `/public_rss_links/${encodeURIComponent(
      ownerVanityId,
    )}/${encodeURIComponent(linkId)}`,
  );

  return parsePublicLink(response);
};
